<template>
    <ScrollPanel style="height: 450px;">
        <div v-for="operation in operations" :key="operation.id">
            <div class="date_and_link_container">
                <span>
                    {{ utils.formatDate(operation.timestamp) }}
                </span>
                <span>
                    <font-awesome-icon :icon="['fas', 'link']" size="lg" style="cursor: pointer; margin: 0 5px;"
                        @click="openOperation(operation.id)" />
                </span>
            </div>
            <div class="h_v_centered_container">
                <img :src="operation.sender.imageUrl" class="user_avatar" tabindex="1"
                    v-tooltip.focus.right="operation.sender.fullName" />
                <font-awesome-icon :icon="['fas', getOperationTypeIcon(operation.typeId)]" />
                <img :src="operation.receiver.imageUrl" class="user_avatar" tabindex="1"
                    v-tooltip.focus.left="operation.receiver.fullName" />
            </div>
        </div>
    </ScrollPanel>
</template>

<script setup>
import { ref, onBeforeMount, onBeforeUnmount, inject } from 'vue'
import { operationTypeEnum } from '@/helpers/Constants'
import { useGlobalStore } from '@/stores/global'
import { useAuthStore } from '@/stores/auth'
import utils from '@/helpers/Utils'
import router from '@/router/router'

const dialogRef = inject("dialogRef")
const globalStore = useGlobalStore()
const authStore = useAuthStore()

const operations = ref([])

onBeforeMount(() => {
    globalStore.registerDialog(dialogRef.value)
    operations.value = dialogRef.value.data.operations
})

onBeforeUnmount(() => {
    globalStore.removeDialog(dialogRef.value)
})

const getOperationTypeIcon = (typeId) => {
    if (typeId === operationTypeEnum.GIFT) {
        return "gift"
    } else if (typeId === operationTypeEnum.BORROWING) {
        return "hand-holding"
    }
    return "hand-holding-hand"
}

const openOperation = (operationId) => {
    globalStore.sharedData = operationId
    dialogRef.value.close()
    authStore.amIAdmin() ? router.push('/controlPanel') : router.push('/operations')
}
</script>

<style scoped>
.user_avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
}

.date_and_link_container {
    text-align: center;
    direction: rtl;
    align-items: center;
    margin: 10px 0;
}

.h_v_centered_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>